import {View} from 'MWComponents';
import tpl from '../templates/share';

const fb = 'facebook',
    li = 'linkedin',
    tlg = 'telegram',
    tw = 'twitter';

export default class extends View {
    template = tpl;

    state = {
        isOpen: false,
        platforms: [fb, li, tlg, tw],
        platformShareFuncs: {
            [tlg]: this.shareTlg.bind(this),
            [li]: this.shareLinkedIn.bind(this),
            [tw]: this.shareTwitter.bind(this),
            [fb]: this.shareFacebook.bind(this)
        }
    };

    toggleOpenState = () => this.setState(prevState => ({isOpen: !prevState.isOpen}));

    handleShareHover = () => this.toggleOpenState();

    handleShareClick = () => {
        if (this.isViewportMobile()) {
            this.toggleOpenState();
        }
    };

    handleIconClick = platformName => {
        const func = this.state.platformShareFuncs[platformName];
        func && func();
    };

    shareTlg() {
        const {url, text} = this.props.options,
            link = `https://telegram.me/share/url?url=${url}&text=${text}`;

        this._shareLink(link);
    }

    shareLinkedIn() {
        const {url} = this.props.options,
            link = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;

        this._shareLink(link);
    }

    shareTwitter() {
        const {url, text, tags} = this.props.options,
            link = `http://www.twitter.com/share?url=${url}&text=${text}&hashtags=${tags}`;

        this._shareLink(link);
    }

    shareFacebook() {
        const {url} = this.props.options,
            url1 = `https://www.facebook.com/sharer/sharer.php?u=${url}&src=sdkpreparse`,
            link = encodeURI(url1);

        this._shareLink(link);
    }

    _shareLink = link => window.open(link, '_blank');

    static displayName = 'Share';
}
